module.exports = __webpack_public_path__ + "static/media/image1.10e092ec.png";